import { FAILED, LOADING, SUCCESS } from './constants';

export const initialState = {
  dataUpdateStock: {
    data: [],
    meta: {
      page: 0,
      totalPage: 0,
      totalData: 0,
    },
  },
  isLoadingUpdateStock: false,
  messageUpdateStock: '',
  id: '',
};

export default function reducer(state = initialState, action) {
  const { type, data, isLoading, message, key } = action;

  switch (type) {
    case FAILED:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: message,
      };
    case LOADING:
      return {
        ...state,
        id: data,
        [`isLoading${key}`]: isLoading,
        [`message${key}`]: '',
      };
    case SUCCESS:
      return {
        ...state,
        [`data${key}`]: data,
        [`isLoading${key}`]: false,
        [`message${key}`]: '',
      };
    default:
      return state;
  }
}
